import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpExtenstionsModel, QueryResultsModel } from '../../_base/crud';
import { PractitionRolesState } from '../_reducers/practition-role.reducers';
import { each } from 'lodash-es';
import { PractitionRole } from '../_models/practition-role.model';

export const selectPractitionRolesState =
  createFeatureSelector<PractitionRolesState>('practitionRoles');

export const selectPractitionRoleById = (practitionRoleId: number) =>
  createSelector(
    selectPractitionRolesState,
    (practitionRolesState) => practitionRolesState.entities[practitionRoleId],
  );

export const selectPractitionRolesPageLoading = createSelector(
  selectPractitionRolesState,
  (practitionRolesState) => {
    return practitionRolesState.listLoading;
  },
);

export const selectPractitionRolesActionLoading = createSelector(
  selectPractitionRolesState,
  (practitionRolesState) => practitionRolesState.actionsloading,
);

export const selectLastCreatedPractitionRoleId = createSelector(
  selectPractitionRolesState,
  (practitionRolesState) => practitionRolesState.lastCreatedPractitionRoleId,
);

export const selectPractitionRolesPageLastQuery = createSelector(
  selectPractitionRolesState,
  (practitionRolesState) => practitionRolesState.lastQuery,
);
export const selectPractitionRoleErrorState = createSelector(
  selectPractitionRolesState,
  (practitionRolesState) => practitionRolesState.error,
);
export const selectPractitionRolesInStore = createSelector(
  selectPractitionRolesState,
  (practitionRolesState) => {
    const items: PractitionRole[] = [];
    each(practitionRolesState.entities, (element) => {
      items.push(element);
    });
    const httpExtension = new HttpExtenstionsModel();
    const result: PractitionRole[] = httpExtension.sortArray(
      items,
      practitionRolesState.lastQuery.sortField,
      practitionRolesState.lastQuery.sortOrder,
    );
    return new QueryResultsModel(result, practitionRolesState.totalCount);
  },
);

export const selectPractitionRolesShowInitWaitingMessage = createSelector(
  selectPractitionRolesState,
  (practitionRolesState) => practitionRolesState.showInitWaitingMessage,
);

export const selectHasPractitionRolesInStore = createSelector(
  selectPractitionRolesState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
